import { Col, Row, Card, Divider, Typography, Space, Button } from "antd";
import { useState } from "react";
const ColorsCard = ({
    leftColor = "#FFF7D9",
    rightColor = "#E5FFE3",
    rowContentFontCount = 2,
    rowMoreInfoFontCount = 3,
    cardContent = "數轉會議",
    moreInfo = "6部門"
}) => {
    // backgroundImage: "linear-gradient(to right, #D9F8FF, #E5FFE3)"
    return (
        <Space
            direction="vertical"
            align='center'
        >
            <Card
                bodyStyle={{
                    padding: "5px 10px"
                }}
                size="small"
                style={{
                    backgroundImage: `linear-gradient(to right, ${leftColor}, ${rightColor})`
                }}
            >
                <Row justify={"center"} >
                    <Col>
                        <div
                            style={{
                                margin: '0px 10px',
                                maxWidth: `${rowContentFontCount * 1.2}rem`,
                                fontWeight: "bold"
                            }}
                        >
                            <div>
                                {cardContent}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Card>
            <div
                style={{
                    overflow: "clip",
                    maxWidth: `${rowMoreInfoFontCount * 0.9}rem`,
                    width: `${rowMoreInfoFontCount * 0.9}rem`,
                    fontSize: "0.9rem",
                }}
            >
                {moreInfo}
            </div>
        </Space>
    )
}

export { ColorsCard }